import { d as r } from "./define-element-Dl91r6Vu.js";
import { Overlay as o } from "./Overlay-DvOyF6kR.js";
r("sp-overlay", o);
//# sourceMappingURL=sp-overlay-D-aFOzDh.js.map
